package com.evoapps.evoshift.domain.usecase.availability

import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class DeleteWeeklyAvailabilityTemplateUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(templateId: String): Result<Unit> {
        return availabilityRepository.deleteWeeklyAvailabilityTemplate(templateId)
    }
}
